import { Category } from '@common/category';

export interface PublicCategoriesState {
  categories: Category[];
  isLoading: boolean;
  error: any;
}

export const initialState: PublicCategoriesState = {
  categories: [],
  isLoading: false,
  error: null
};
